import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/SaveMoneyIllustration.tsx
const SaveMoneyIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "save-money.svg",
		alt: t("illustration.imageAlt.wallet")
	});
};

//#endregion
export { SaveMoneyIllustration };